<template>
  <div>
    <div style="margin-top: 1rem; display: flex;">
      <full-screen
        eid='main-dashboard'
      />
      <div style="padding-left: 1rem;">
        全螢幕
      </div>
    </div>

    <b-card id='main-dashboard' title="Output%">
      <!-- 錯誤訊息顯示區域 -->
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
      <!-- 圖表組件 -->
      <sag-output-chart 
        v-if="!error && chartData"
        :chart-data="chartData" 
        class="mt-2"
      />
      <!-- 載入中提示 -->
      <div v-if="loading" class="text-center">
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </b-card>
  </div>
</template>

<script>
/**
 * 產出圖表組件
 * 
 * 日誌查看方式：
 * 1. 打開瀏覽器開發者工具 (F12)
 * 2. 切換到 Console 頁籤
 * 3. 可以看到以下格式的日誌：
 *    - <DEBUG>[API Request]: 請求數據
 *    - <DEBUG>[API Response]: API 響應
 *    - <ERROR>[API Error]: API 錯誤
 * 
 * 日誌標籤說明：
 * - DEBUG: 一般調試信息
 * - ERROR: 錯誤信息
 */

import SagOutputChart from '@/components/sag-kan-chart/SagOutputChart.vue'
import ApiKan from '@/components/sag-kan-chart/js/api'
import { BCard, BSpinner } from 'bootstrap-vue'
import tools from '@/sag-core/tools'
import FullScreen from '@/components/basic/FullScreen.vue'

export default {
  name: 'KANMDTUI02',
  
  // 註冊使用的組件
  components: {
    BCard,
    BSpinner,
    SagOutputChart,
    FullScreen,
  },

  // 組件數據
  data() {
    return {
      // 圖表數據
      // 格式: {
      //   Plan: [{ Date: "2024-11-25T00:00:00", Value: "3516000" }],
      //   Achieve: [{ Date: "2024-11-05T00:00:00", Value: "66%" }],
      //   ProdData: [{ Label: "ILT", Date: "2024-11-05T00:00:00", Value: "234000" }]
      // }
      chartData: null,
      
      // 錯誤訊息
      error: null,

      // 載入狀態
      loading: false,

      // API 實例
      api: new ApiKan()
    }
  },

  methods: {
    /**
     * 驗證圖表數據格式
     * @param {Object} data - API 返回的數據
     * @returns {boolean} - 數據格式是否有效
     */
    validateChartData(data) {
      tools.debug.log({tag: 'DEBUG', title: 'Validating Chart Data', content: data})
      
      // 檢查必要的數據陣列是否存在
      return data && 
             Array.isArray(data.Plan) && 
             Array.isArray(data.Achieve) && 
             Array.isArray(data.ProdData)
    },

    /**
     * 獲取圖表數據
     * 從 API 獲取產出相關數據，包括計劃值、達成率和產出數據
     * 
     * 日誌輸出：
     * - 請求數據：<DEBUG>[Request Data]
     * - API 響應：<DEBUG>[API Response]
     * - 數據驗證：<DEBUG>[Validating Chart Data]
     * - 錯誤信息：<ERROR>[API Error]
     */
    async fetchData() {
      try {
        this.error = null
        this.loading = true

        // API 請求參數
        const requestData = {
          StartDate: '2024-09-01',  // 開始日期
          EndDate: '2024-11-30',    // 結束日期
          ConfigID: 1               // 配置 ID
        }
        
        // 記錄請求數據
        tools.debug.log({tag: 'DEBUG', title: 'Request Data', content: requestData})
        
        // 調用 API
        const response = await this.api.apiGetMFGOutput(requestData)
        tools.debug.log({tag: 'DEBUG', title: 'API Response', content: response})
        
        // 驗證並設置數據
        if (this.validateChartData(response)) {
          this.chartData = response
          tools.debug.log({tag: 'DEBUG', title: 'Chart Data Set', content: this.chartData})
        } else {
          this.error = '數據格式不正確'
          tools.debug.log({tag: 'ERROR', title: 'Invalid Data Format', content: response})
        }
      } catch (error) {
        // 處理具體的錯誤類型
        if (error.status === undefined) {
          this.error = '網路連接失敗或CORS錯誤'
        } else {
          this.error = error.message || '獲取資料失敗'
        }
        
        tools.debug.log({tag: 'ERROR', title: 'API Error', content: error})
        console.error('獲取資料失敗:', error)
      } finally {
        this.loading = false
      }
    }
  },

  // 組件創建時獲取數據
  created() {
    this.fetchData()
  }
}
</script>

<style scoped>
.alert {
  margin-bottom: 1rem;
}
</style>
